/* eslint-disable no-return-assign */

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-unused-vars */

/* eslint-disable no-use-before-define */

/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import React, {useEffect, useRef, useState} from "react";
import {
  HelpCircle as HelpCircleIcon,
  ShoppingCart as ShoppingCartIcon
} from "react-feather";
import {useIntl} from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import {useSelector} from "react-redux";
import {matchPath, useLocation} from "react-router";
import {Link as RouterLink} from "react-router-dom";

import _ from "lodash";
import {useSnackbar} from "notistack";

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  makeStyles
} from "@material-ui/core";
import Logo from "src/components/Logo";

import useSettings from "src/hooks/useSettings";

import NavBarAdvance from "./NavBarAdvance";
import NavConfig from "./NavBarTree";
import NavItem from "./NavItem";

function renderNavItems({items, ...rest}) {
  return (
    <List disablePadding>
      {items.reduce((acc, item) => reduceChildRoutes({acc, item, ...rest}), [])}
    </List>
  );
}

function reduceChildRoutes({acc, pathname, item, depth = 0}) {
  const key = item.title + depth;
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)"
  },
  desktopDrawerOnlyIcon: {
    width: 100,
    top: 64,
    height: "calc(100% - 64px)"
  },
  avatar: {
    cursor: "pointer",
    width: 50,
    height: 50
  },
  active: {
    color: theme.palette.secondary.main,

    "& $title": {
      fontWeight: theme.typography.fontWeightMedium
    },
    "& $icon": {
      color: theme.palette.secondary.main
    }
  },
  button: {
    width: "100%",
    alignItems: "center",
    marginTop: 10
  },
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  }
}));

const checkItemValid = (idNeedCheck) => {
  const localListUIConfig = JSON.parse(localStorage.getItem("listUIConfig"));
  const checkValid = _.find(
    localListUIConfig,
    (itemConfig) => itemConfig.attribute_value === idNeedCheck
  );
  if (!checkValid) return false;
  return true;
};

const validateWithUIConfig = (navTree) => {
  const newnNavTree = [];
  _.map(navTree, (parentItem) => {
    if (parentItem.subheader) {
      if (checkItemValid(parentItem.idSubheader)) {
        const newItems = _.cloneDeep(parentItem.items);
        const test = _.remove(
          newItems,
          (eachDropdown) => !checkItemValid(eachDropdown.idDropdown)
        );
        parentItem.items = newItems;
        newnNavTree.push(parentItem);
      }
    }
    return null;
  });
  return newnNavTree;
};

function NavBar({openMobile, onMobileClose}) {
  const classes = useStyles();
  const {formatMessage} = useIntl();
  const location = useLocation();
  const {user} = useSelector((state) => state.account);
  const {settings} = useSettings();
  const navRef = useRef({});
  // const itemScrollRef = useRef({});

  const {enqueueSnackbar} = useSnackbar();
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  const checkAdminRoleExist = _.find(user.roles.data, (role) => role.key === "owner");
  const filterNavTree = checkAdminRoleExist
    ? NavConfig()
    : validateWithUIConfig(NavConfig());

  useEffect(() => {
    if (navRef?.current && location.pathname) {
      setTimeout(() => {
        scrollItemNavTree();
      }, 0);
    }
  }, []);
  const scrollItemNavTree = () => {
    try {
      const findItem = filterNavTree.find((item) =>
        item?.items?.some(
          (header) =>
            header?.href === location.pathname ||
            header?.items?.some((dropdown) => dropdown.href === location.pathname)
        )
      );
      if (findItem) {
        const subheader = findItem.idSubheader;

        if (navRef.current[subheader]) {
          navRef.current[subheader].scrollIntoView();
        }
      }
    } catch (error) {
      enqueueSnackbar(error ?? "Something wrong!", {
        variant: "error"
      });
    }
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box p={2}>
        <Box display="flex" justifyContent="center">
          <RouterLink to="/app/account">
            <Avatar
              alt={user.avatar ? user.avatar : "User"}
              className={classes.avatar}
              src={user.avatar ? user.avatar : ""}
            >
              {user.avatar
                ? user.avatar
                : user.first_name && user.last_name
                ? `${user.first_name.substring(0, 1).toUpperCase()}${user.last_name
                    .substring(0, 1)
                    .toUpperCase()}`
                : "AD"}
            </Avatar>
          </RouterLink>
        </Box>
        <Box mt={2} textAlign="center">
          <Link
            component={RouterLink}
            to="/app/account"
            variant="h5"
            color="textPrimary"
            underline="none"
          >
            {user.first_name && user.last_name
              ? `${user.first_name} ${user.last_name}`
              : formatMessage({
                  id: "dashboardLayout-navBar-rZvqu",
                  defaultMessage: "Updating",
                  description: ""
                })}
          </Link>
          <Typography variant="body2" color="textSecondary">
            {user.bio}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <PerfectScrollbar options={{suppressScrollX: true}}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>

        <Box p={2}>
          {filterNavTree.map((config) => (
            <List
              ref={(el) => (navRef.current[config.idSubheader] = el)}
              key={config.subheader}
              subheader={
                <ListSubheader
                  disableGutters
                  disableSticky
                  id={config.idSubheader}
                  style={{
                    textTransform: "uppercase"
                  }}
                >
                  {config.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: config.items,
                pathname: location.pathname
              })}
            </List>
          ))}
        </Box>
        <Divider />
        <Box p={2}>
          <Box p={2} borderRadius="borderRadius" bgcolor="background.dark">
            <Typography variant="h6" color="textPrimary">
              {formatMessage({
                id: "dashboardLayout-navBar-QidMW",
                defaultMessage: "Need Help?",
                description: ""
              })}
            </Typography>
            <Link variant="subtitle1" color="secondary" component={RouterLink} to="/#">
              {formatMessage({
                id: "dashboardLayout-navBar-erRfU",
                defaultMessage: "Check our docs",
                description: ""
              })}
            </Link>
          </Box>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  // const contentOnlyIcon = (
  //   <Box height="100%" display="flex" flexDirection="row">
  //     <PerfectScrollbar options={{suppressScrollX: true}}>
  //       <Hidden lgUp>
  //         <Box p={2} display="flex" justifyContent="center">
  //           <RouterLink to="/">
  //             <Logo />
  //           </RouterLink>
  //         </Box>
  //       </Hidden>
  //       <Box p={2}>
  //         <Box display="flex" justifyContent="center">
  //           <RouterLink to="/app/account">
  //             <Avatar alt="User" className={classes.avatar} src={user.avatar} />
  //           </RouterLink>
  //         </Box>
  //       </Box>
  //       <Divider />
  //       <Box p={2}>
  //         {filterNavTree.map((config, index) => {
  //           const IconName = config.iconHeader;
  //           return (
  //             <Button
  //               key={index}
  //               component={RouterLink}
  //               activeClassName={classes.active}
  //               className={classes.button}
  //               to={config.items.length > 0 && config.items[0].href}
  //             >
  //               {config.iconHeader ? <IconName /> : <ShoppingCartIcon />}
  //             </Button>
  //           );
  //         })}
  //       </Box>
  //       <Divider />
  //       <Box p={2}>
  //         <Box p={2}>
  //           <Link variant="subtitle1" color="secondary" component={RouterLink} to="/docs">
  //             <HelpCircleIcon />
  //             {formatMessage({
  //               id: "dashboardLayout-navBar-xVyOi",
  //               defaultMessage: "Help",
  //               description: ""
  //             })}
  //           </Link>
  //         </Box>
  //       </Box>
  //     </PerfectScrollbar>
  //   </Box>
  // );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{paper: classes.mobileDrawer}}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        {settings.showMenuIcon ? (
          // <Drawer
          //   anchor="left"
          //   classes={{ paper: classes.desktopDrawerOnlyIcon }}
          //   open
          //   variant="persistent"
          // >
          //   {contentOnlyIcon}
          // </Drawer>
          <NavBarAdvance />
        ) : (
          <Drawer
            anchor="left"
            classes={{paper: classes.desktopDrawer}}
            open
            variant="persistent"
          >
            {content}
          </Drawer>
        )}
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
